import styled from "styled-components"
import {
  DotsLoader as BaseDotsLoader,
  type DotsLoaderProps,
} from "~/ur-react-components"

const StyledDotsLoader = styled(BaseDotsLoader)``

export const DotsLoader: React.CFC<DotsLoaderProps> = ({ ...props }) => {
  return <StyledDotsLoader {...props} />
}
